import { Checkbox, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/shared/components";
import { convertToKebabCase } from "@/shared/utils";
import { FieldPath, FieldValues, UseFormReturn } from "react-hook-form";

interface CheckboxFormFieldProps<T extends FieldValues> {
    form: UseFormReturn<T>;
    label?: string;
    name: FieldPath<T>;
    readOnly?: boolean;
}

export function CheckboxFormField<T extends FieldValues>({ form, label, name, readOnly }: Readonly<CheckboxFormFieldProps<T>>) {
    return (
        <FormField
            control={form.control}
            name={name}
            render={({ field }) => (
                <FormItem className="flex items-center gap-2" data-testid={`form-item${convertToKebabCase(label ? `-${label}` : "")}`}>
                    <FormControl>
                        <Checkbox checked={field.value} onCheckedChange={field.onChange} disabled={readOnly} {...field} />
                    </FormControl>
                    {label && <FormLabel className="text-content-default font-normal peer-disabled:opacity-100">{label}</FormLabel>}
                    <FormMessage />
                </FormItem>
            )}
        />
    );
}
